module.exports = __webpack_public_path__ + "img/ken2pt0.5ae799c3.jpg";